import MainLayout from "@/components/layouts";
import PropertyCard from "@/app/pmc/properties/properties.components/property-card";
import { useProperties } from "./properties.hooks";
import DataWrapper from "@/components/shared/wrapper";
import { FilterItem } from "@/interfaces";
import { PROPERTY_CLASSES, PROPERTY_STRUCTURES, PROPERTY_TYPES } from "@/lib/enums";
import { capitalize } from "@/lib/utils";
import { PropertyModal } from "@/app/pmc/properties/properties.components/property-modal.tsx";

export default function Component() {
  const { list, filters, loading, creating, openCreateModal, closeCreateModal, handleCreate } = useProperties();

  const { page, pageSize, total, setPropertyPage, setPropertyPageSize } = filters;

  const mainLayoutProps = {
    breadcrumb: [
      {
        name: "Properties",
        href: "#",
      },
    ],
    pageHeader: {
      title: "Properties",
      subtitle: "Manage your properties here",
      buttonText: "+ Add Property",
      onButtonClick: () => openCreateModal(),
    },
  };

  const filterItems: FilterItem[] = [
    {
      type: "search",
      title: "Search For Properties",
      value: "",
      onValueChange: (val) => {
        console.log(val);
      },
      grid: 6,
    },
    {
      type: "select",
      title: "Select Property Type",
      value: filters.type,
      onValueChange: filters.setPropertyType,
      options: PROPERTY_TYPES.map((type) => ({ label: capitalize(type), value: type })),
    },
    {
      type: "select",
      title: "Select Property Structure",
      value: filters.structure,
      onValueChange: filters.setPropertyStructure,
      options: PROPERTY_STRUCTURES.map((type) => ({ label: capitalize(type), value: type })),
    },
    {
      type: "select",
      title: "Select Property Class",
      value: filters.class,
      onValueChange: filters.setPropertyClass,
      options: PROPERTY_CLASSES.map((type) => ({ label: capitalize(type), value: type })),
    },
  ];

  const dataWrapperProps = {
    length: list.length,
    page,
    pageSize,
    total,
    setPage: setPropertyPage,
    setPageSize: setPropertyPageSize,
    pageSizeOptions: [9, 18, 27, 36],
    loading,
    filters: filterItems,
    onReset: filters.resetPropertyFilters,
  };

  return (
    <MainLayout {...mainLayoutProps}>
      <DataWrapper {...dataWrapperProps}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((property, key) => (
            <PropertyCard key={key} property={property} />
          ))}
        </div>
      </DataWrapper>

      <PropertyModal open={creating} onOpenChange={(open) => !open && closeCreateModal()} onSubmit={handleCreate} />
    </MainLayout>
  );
}
